export default __webpack_public_path__ + "static/Seo1-c4a8bab90d8fccf93e51fa1274ef716b.jpg";